export default "__VITE_ASSET__B4FR0NXY__"